import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ModalsHandlerService } from '../modals.handler.service';

@Component({
  selector: 'ngx-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent implements OnInit, OnDestroy {

  @ViewChild('content', { static: false }) content: Element;
  closeResult: string;
  confirmModalSubcription: Subscription;

  static getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    }
    if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    }

    return `with: ${reason}`;
  }

  constructor(
    private readonly modalsHandler: ModalsHandlerService,
    private readonly modalService: NgbModal,

  ) { }

  ngOnInit() {
    this.confirmModalSubcription = this.modalsHandler.confirmModal.subscribe(data => {
      this.open(this.content);
    });
  }

  ngOnDestroy() {
    this.confirmModalSubcription.unsubscribe();
  }

  open(content: any): void {
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      backdrop: 'static', keyboard: false
    }).result.then(() => undefined, reason => {
      this.closeResult = `Dismissed ${ConfirmModalComponent.getDismissReason(reason)}`;
    });
  }

  success() {
    this.modalsHandler.sendConfirmationModalResult(true);
    this.modalService.dismissAll();
  }

  close() {
    this.modalsHandler.sendConfirmationModalResult(false);
    this.modalService.dismissAll();
  }
}
